var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPossiblepayments01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 54,
    viewBox: "0 0 84 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_42511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.829452,
    y: 0.991561,
    width: 82.0519,
    height: 51.9104,
    rx: 4.18632,
    fill: "white",
    stroke: "#E7EAEE",
    strokeWidth: 1.67453
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6156 36.2158H32.4609L35.685 17.7366H40.8394L37.6156 36.2158Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2985 18.1886C55.2817 17.8147 53.6691 17.4019 51.6751 17.4019C46.5848 17.4019 43.0002 19.918 42.9782 23.5154C42.9359 26.1696 45.5447 27.6438 47.4958 28.5288C49.4901 29.4331 50.168 30.0233 50.168 30.8294C50.1477 32.0674 48.5565 32.638 47.0724 32.638C45.0144 32.638 43.9118 32.3438 42.236 31.6551L41.5573 31.3598L40.8359 35.508C42.0449 36.0185 44.2723 36.4716 46.5848 36.4915C51.9934 36.4915 55.5146 34.0142 55.5563 30.1806C55.5769 28.077 54.1993 26.4651 51.2295 25.148C49.4266 24.3024 48.3225 23.7323 48.3225 22.8672C48.3437 22.0807 49.2564 21.2752 51.2915 21.2752C52.9673 21.2357 54.1985 21.6091 55.1312 21.9827L55.5974 22.179L56.2985 18.1886Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.147 29.6693C63.5715 28.6077 65.2049 24.4989 65.2049 24.4989C65.1835 24.5384 65.6286 23.4177 65.8831 22.7298L66.2433 24.322C66.2433 24.322 67.2195 28.7454 67.4314 29.6693C66.6259 29.6693 64.1651 29.6693 63.147 29.6693ZM69.5097 17.7366H65.5226C64.2931 17.7366 63.3589 18.0705 62.8284 19.2698L55.1719 36.2156H60.5805C60.5805 36.2156 61.4709 33.9348 61.6623 33.4436C62.2557 33.4436 67.5171 33.4436 68.2805 33.4436C68.4284 34.0923 68.8955 36.2156 68.8955 36.2156H73.6682L69.5097 17.7366Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.156 17.7366L23.108 30.3377L22.5563 27.782C21.623 24.8331 18.6961 21.6292 15.4297 20.0362L20.0536 36.1962H25.5045L33.6067 17.7366H28.156Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4172 17.7366H10.1239L10.0391 18.11C16.5084 19.6434 20.7929 23.3399 22.5532 27.7828L20.7503 19.2899C20.4535 18.1097 19.5413 17.7755 18.4172 17.7366Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_42511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.7264,
    height: 53.5849,
    fill: "white",
    transform: "translate(0 0.154297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossiblepayments01);
export default __webpack_public_path__ + "static/media/Possiblepayments01.ef9a3f091e46fb1636c416b02be1caa2.svg";
export { ForwardRef as ReactComponent };